import React, { Component } from 'react';
import say_play_btn from '../../image/home/say_play_btn.png';
import { translate } from "react-i18next";

class Rolling extends Component {
    roll(s) {
        let el = document.getElementById('rolling_1');
        let maxScrollLeft = el.scrollWidth - el.clientWidth;

        if (this.state.left) {
            if (s < 1) {
                el.scrollLeft = maxScrollLeft;
                this.setState({ time: maxScrollLeft });
            } else {
                el.scrollLeft = s;
            }
        } else {
            if (s < maxScrollLeft) {
                el.scrollLeft = s;
            } else {
                el.scrollLeft = 0;
                this.setState({ time: 0 });
            }

        }

    }
    start() {
        this.setState({ stop: false });
    }
    stop() {
        this.setState({ stop: true });
    }

    state = {
        time: 0,
        fast: false,
        left: false,
        stop: false,
    }
    updateVideo(type) {
        let path = window.location.pathname
        path = path.slice(1, 3);
        let videoSrc;
        if (type === 'partner_1') {
            if (path === 'en') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/Partners_ASHRAE_11Aug_Eng_v3.mp4';
            } else if (path === 'sc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/ASHRAE_SC.mp4';
            } else if (path === 'tc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/ASHRAE_TC.mp4';
            }
        } else if (type === 'partner_2') {
            if (path === 'en') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/Partners_CIBSE_Eng_v2.mp4';
            } else if (path === 'sc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/CIBSE_SC.mp4';
            } else if (path === 'tc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/CIBSE_TC.mp4';
            }
        } else if (type === 'partner_3') {
            if (path === 'en') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/Partners_Cyberport_Peter%20Yan_English_20210928_FINAL.mp4';
            } else if (path === 'sc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/Cyberport_SC.mp4';
            } else if (path === 'tc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/Cyberport_TC.mp4';
            }
        } else if (type === 'partner_4') {
            if (path === 'en') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/Partners_HKSTP%20CEO%20Albert%20Wong_English_20210928_FINAL.mp4';
            } else if (path === 'sc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/HKSTP_SC.mp4';
            } else if (path === 'tc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/HKSTP_TC.mp4';
            }
        } else if (type === 'partner_5') {
            if (path === 'en') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/Partners_IEEE_Cheung%20Yiu%20Ming_English_20210928_FINAL.mp4';
            } else if (path === 'sc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/IEEE_SC.mp4';
            } else if (path === 'tc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/IEEE_TC.mp4';
            }
        } else if (type === 'partner_6') {
            if (path === 'en') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/Partners_OGCIO_Victor%20Lam_English_20210928_FINAL.mp4';
            } else if (path === 'sc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/OGCIO_SC.mp4';
            } else if (path === 'tc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/OGCIO_TC.mp4';
            }
        } else if (type === 'partner_7') {
            if (path === 'en') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/Partners_WGBC_Eng_v3.mp4';
            } else if (path === 'sc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/WGBC_SC.mp4';
            } else if (path === 'tc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/WGBC_TC.mp4';
            }
        } else if (type === 'partner_8') {
            if (path === 'en') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/Partners_ASD_Winnie%20Ho_English_20210930_FINAL.mp4';
            } else if (path === 'sc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/ASD_SC.mp4';
            } else if (path === 'tc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/ASD_TC.mp4';
            }
        } else if (type === 'partner_9') {
            if (path === 'en') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/Partners_IBM_Kitty%20Wong_English_20210928_FINAL.mp4';
            } else if (path === 'sc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/IBM_SC.mp4';
            } else if (path === 'tc') {
                videoSrc = 'https://storage.googleapis.com/emsd_video/IBM_TC.mp4';
            }
        }
        let video = document.getElementById('video');

        video.setAttribute('src', videoSrc + "?autoPlay=1&amp;modestbranding=1&amp;showinfo=0");
    }
    componentDidMount() {
        let path = window.location.pathname
        path = path.slice(1, 3);
        if (path === 'en') {
            require("./rolling.css");
        } else if (path === 'sc') {
            require("./rolling_sc.css");
        } else if (path === 'tc') {
            require("./rolling_tc.css");
        }
        setInterval(() => {
            let p = 0;
            if (this.state.stop) {
                p = this.state.time;
            } else {
                if (this.state.left) {
                    p = this.state.time - 5;
                } else {
                    if (this.state.fast) {
                        p = this.state.time + 5;
                    } else {
                        p = this.state.time + 1;
                    }
                }
            }

            this.setState({ time: p });
        }, 50)
    }
    componentDidUpdate() {
        this.roll(this.state.time);

    }

    render() {
        const { t } = this.props;

        return (
            <div id="hear-partner" className={t('hear-partner-css')}>
                <div className="rolling-left" onMouseEnter={() => { this.setState({ fast: true, left: true }); }} onMouseLeave={() => { this.setState({ fast: false, left: false }); }}></div>
                <div className="d-flex align-items-center arrow-box">
                    <div className="arrow-left">
                    </div>
                    <div>
                        <div className="div-rolling-top"></div>
                        <div id="rolling_1" className="div-partners d-flex" onMouseEnter={() => this.stop()} onMouseLeave={() => this.start()}>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-center">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-1 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_1')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-1')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-1')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-1')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-end">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-2 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_2')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-2')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-2')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-2')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-start">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-3 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_3')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-3')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-3')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-3')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-center">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-4 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_4')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-4')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-4')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-4')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-end">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-5 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_5')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-5')}</div>
                                        <div className="title-company-swap">
                                            <div className="mt-0">
                                                <div className="partner-title">{t('partner-title-5-1')}</div>
                                                <div className="partner-title-2">{t('partner-title-5-2')}</div>
                                            </div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-5')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-start">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-6 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_6')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-6')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-6')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-6')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-center">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-7 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_7')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-7')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-7')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-7')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-end">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-8 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_8')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-8')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-8')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-8')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-end">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-9 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_9')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-9')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-9')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-9')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-center">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-1 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_1')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-1')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-1')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-1')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-end">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-2 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_2')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-2')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-2')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-2')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-start">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-3 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_3')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-3')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-3')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-3')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-center">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-4 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_4')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-4')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-4')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-4')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-end">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-5 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_5')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-5')}</div>
                                        <div className="title-company-swap">
                                            <div className="mt-0">
                                                <div className="partner-title">{t('partner-title-5-1')}</div>
                                                <div className="partner-title-2">{t('partner-title-5-2')}</div>
                                            </div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-5')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-start">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-6 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_6')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-6')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-6')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-6')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-center">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-7 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_7')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-7')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-7')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-7')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-end">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-8 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_8')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-8')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-8')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-8')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="partner d-flex justify-content-center">
                                <div className="d-flex flex-column justify-content-end">
                                    <div className="partner-img-outer">
                                        <div className="partner-img-inner partner-img-9 d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('partner_9')}>
                                            <div className="d-flex align-items-center">
                                                <img src={say_play_btn} className="say_play_btn" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partner-info text-center">
                                        <div className={t('TXT_bold partner-name')}>{t('partner-name-9')}</div>
                                        <div className="title-company-swap">
                                            <div className="partner-title">{t('partner-title-9')}</div>
                                            <div className={t('TXT_bold partner-company')}>{t('partner-company-9')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex align-items-center arrow-box">
                        <div className="arrow-right"></div>
                    </div>
                    <div className="rolling-right" onMouseEnter={() => { this.setState({ fast: true }); }} onMouseLeave={() => { this.setState({ fast: false }); }}></div>
                </div>
            </div>
        );

    }
}
export default translate("translations")(Rolling);



// WEBPACK FOOTER //
// ./src/components/widget/rolling.js